import { useCallback } from "react"
import cn from "classnames"

import { SortDirection } from "config/constants"
import toastMessages from "stores/toastMessages"
import { TableColumn, TableHeaderTheme, TableTheme } from "./Table"

interface IUseTableParams {
    isLoading?: boolean
    theme: TableTheme
    headerTheme: TableHeaderTheme
    condensed?: boolean
    stickyHeader?: boolean
    withFreeze?: boolean
    horizontallyScrolledToStart?: boolean
    horizontallyScrolledToEnd?: boolean
    bordered?: boolean
    round?: boolean
    useAdvancedScrolling?: boolean
}

export default function useTable({
    isLoading,
    theme,
    headerTheme,
    condensed,
    stickyHeader,
    withFreeze,
    horizontallyScrolledToStart,
    horizontallyScrolledToEnd,
    bordered,
    round,
    useAdvancedScrolling
}: IUseTableParams) {
    const handleSortChange = useCallback(async (col: TableColumn) => {
        if (isLoading) return
        try {
            await col.onSortChange?.(col.sort === SortDirection.asc ? SortDirection.desc : SortDirection.asc)
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [isLoading])

    const tableClassName = cn(
        "table h-100", `table--theme-${theme}`, `table--header-theme-${headerTheme}`,
        { "table--with-freeze": withFreeze },
        { "table--horizontally-scrolled-to-start": withFreeze && horizontallyScrolledToStart },
        { "table--horizontally-scrolled-to-end": withFreeze && horizontallyScrolledToEnd },
        { "table--condensed": condensed },
        { "table--sticky-header": stickyHeader },
        { "table--loading": isLoading },
        { "table--bordered": bordered },
        { "table--advanced-scrolling": useAdvancedScrolling },
        { "round-sm": round }
    )

    return {
        handleSortChange,
        tableClassName,
    }
}
